export const formatCurrency = (amount) => {
  if (!amount && amount !== 0) return '£0';
  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: 'GBP',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const formatNumber = (num) => {
  if (!num && num !== 0) return '0';
  if (num >= 1000000) return (num / 1000000).toFixed(1) + 'M';
  if (num >= 1000) return (num / 1000).toFixed(1) + 'K';
  return new Intl.NumberFormat('en-GB').format(num);
};

export const formatPercent = (value) => {
  if (!value && value !== 0) return '0%';
  return parseFloat(value).toFixed(1) + '%';
};

export const formatValue = (value, format) => {
  switch (format) {
    case 'currency': return formatCurrency(value);
    case 'number': return formatNumber(value);
    case 'percent': return formatPercent(value);
    default: return String(value ?? '');
  }
};

export const getNestedValue = (obj, path) => {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, key) => acc?.[key], obj);
};
